const pair = /(-?\d{1,3}(?:\.\d+)?)[, ]+(-?\d{1,3}(?:\.\d+)?)/;

export function mapCoordinates(url: string): [number, number] | null {
  try {
    const parsed = new URL(url);
    if (!supportedMapUrl(parsed)) return null;
    const host = parsed.hostname.toLowerCase();
    const decoded = decodeURIComponent(url);
    let match = decoded.match(/@(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/)
      ?? decoded.match(/!3d(-?\d+(?:\.\d+)?)!4d(-?\d+(?:\.\d+)?)/);
    if (match) return valid(Number(match[1]), Number(match[2]));

    if (host.includes("yandex.")) {
      match = (parsed.searchParams.get("ll") ?? parsed.searchParams.get("pt") ?? "").match(pair);
      return match ? valid(Number(match[2]), Number(match[1])) : null;
    }
    match = ["q", "query", "destination", "center"]
      .map((key) => parsed.searchParams.get(key) ?? "")
      .join(" ")
      .match(pair);
    return match ? valid(Number(match[1]), Number(match[2])) : null;
  } catch {
    return null;
  }
}

export function locationPreviewUrl(
  locationUrl: string,
  latitude: string,
  longitude: string,
): string | null {
  const link = locationUrl.trim();
  if (link) {
    try {
      const parsed = new URL(link);
      if (supportedMapUrl(parsed)) return parsed.toString();
    } catch {
      return null;
    }
  }
  const lat = Number(latitude);
  const lng = Number(longitude);
  return latitude.trim() && longitude.trim() && valid(lat, lng)
    ? `geo:${lat},${lng}?q=${lat},${lng}`
    : null;
}

function supportedMapUrl(url: URL): boolean {
  if (!["http:", "https:"].includes(url.protocol)) return false;
  const host = url.hostname.toLowerCase();
  return host === "maps.app.goo.gl"
    || host === "goo.gl"
    || host === "google.com"
    || host.endsWith(".google.com")
    || /^(?:maps\.)?google\.[a-z.]+$/.test(host)
    || host === "yandex.com"
    || host.endsWith(".yandex.com")
    || host.startsWith("maps.yandex.")
    || host.startsWith("yandex.");
}

function valid(lat: number, lng: number): [number, number] | null {
  return Number.isFinite(lat) && Number.isFinite(lng)
    && lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180
    ? [lat, lng]
    : null;
}
